module.exports = __webpack_public_path__ + "static/media/product-real-time.5a08efb8.svg";